export default "__VITE_ASSET__WSRCxa$Y__"